export const FETCH_PLAN_SHIPMENT_DATA = "calendarView/fetch-plan-shipment-data"
export const FETCH_PLAN_SHIPMENT_DATA_SUCCESS =
    "calendarView/fetch-plan-shipment-data-success"

export const FETCH_TOTAL_PLANNED_CAR_DATA =
    "calendarView/fetch-tatalplannedcars-data"
export const FETCH_TOTAL_PLANNED_CAR_DATA_SUCCESS =
    "calendarView/fetch-tatalplannedcars-data-success"

export const UPDATE_PLAN_COUNT = "calendarView/update-plan-count"
export const UPDATE_PLAN_COUNT_SUCCESS =
    "calendarView/update-plan-count-success"
export const SET_FROCASTING_CALCULATIONS =
    "calendarView/set_forcasting_calculations"
